import moment from "moment";

export default {
  formatDate(val){
    return moment(val).format('YYYY-MM-DD');
  },
  formatDateDot(val){
    return moment(val).format('YYYY.MM.DD HH:mm');
  },
  mobile(val){
    return val?val.substring(0,3)+'****'+val.substring(7):"";
  },
};



// WEBPACK FOOTER //
// ./src/filter/index.js